// ストックリストの操作関連の関数群の定義
// ストックリストは以下のような定義になっている
// `${followlist_id},${follow_list_name},${create_user_name},${create_user_id}`
//  [
//    "111,1番目のストック,みがわり,interimadd",
//    "222,2番目のストック,みがわり,interimadd",
//    "333,3番目のストック,みがわり,interimadd"
//  ]

export const findListIdx = (lists_array, list_id) => {
  const isFindArray = (list_info) => list_info.split(",")[0] == list_id
  const list_index = lists_array.findIndex(isFindArray)
  return list_index
}

export const judge_is_valid_list = (lists_array) => {
  if(Array.isArray(lists_array) == false) return false
  if(lists_array.length == 0) return false
  const is_valid_list_info = (list_info) => list_info.split(",").length >= 2
  for(let idx in lists_array){
    if(is_valid_list_info(lists_array[idx]) == false){
        return false
    }    
  }
  return true
}

export const get_list_name_by_id = (lists_array, list_id) => {
  const list_index = findListIdx(lists_array, list_id)
  if(list_index == -1) return ""
  const list_name = lists_array[list_index].split(",")[1]
  return list_name
}

export const change_lists_order_up = (lists_array, list_id) => {
  const lists_array_copy = [...lists_array]
  const list_index = findListIdx(lists_array_copy, list_id)
  if(list_index == -1 || list_index == 0) return lists_array_copy
  lists_array_copy.splice(list_index-1, 2, lists_array_copy[list_index], lists_array_copy[list_index-1]);  // 前の要素と入れ替え
  return lists_array_copy
}

export const change_lists_order_down = (lists_array, list_id) => {
  const lists_array_copy = [...lists_array]
  const list_index = findListIdx(lists_array_copy, list_id)
  if(list_index == -1 || list_index == (lists_array_copy.length-1)){
    return lists_array_copy
  }
  lists_array_copy.splice(list_index, 2, lists_array_copy[list_index+1], lists_array_copy[list_index]);  // 後ろの要素と入れ替え
  return lists_array_copy
}

export const change_list_name = (lists_array, list_id, name) => {
  const lists_array_copy = [...lists_array]
  const list_index = findListIdx(lists_array_copy, list_id)
  if(list_index == -1) return lists_array_copy
  let splited_info = lists_array_copy[list_index].split(",")
  splited_info[1] = name
  const modifed_info = splited_info.join(",")
  lists_array_copy[list_index] = modifed_info
  return lists_array_copy
}

export const get_parsed_list_array = (lists_array) => {
  return lists_array.map((list_info)=>{
    const list_id = list_info.split(",")[0]
    const list_name = list_info.split(",")[1]
    const create_user_name = list_info.split(",")[2]  // 要素がなくてもundefinedになるだけなのでセーフ
    const create_user_id = list_info.split(",")[3]
    return {list_id, list_name, create_user_name, create_user_id}
  })
}

export const add_stock_to_list = (lists_array, list_id, list_name,
                                  create_user_name, create_user_id) => {
  let lists_array_copy = [...lists_array]
  const list_info = `${list_id},${list_name},${create_user_name},${create_user_id}`
  lists_array_copy.push(list_info)
  return lists_array_copy
}

export const remove_stock_from_lists_by_id = (lists_array, list_id) => {
  return lists_array.filter((elm)=> elm.split(",")[0] != list_id)
}

export const isValidListName = (listName) => {
  if(listName.length < 3) return false
  if(listName.length > 30) return false
  if(listName.indexOf(',') != -1) return false
  return true
}